import React, { useEffect } from 'react';
import { Select, Spin, Empty, Col } from 'antd';
import useSWR from 'swr';
import dataArrayHandle from '../../function/dataArrayHandle';
import BaseProps from '../BaseProps/baseProps';
import { FormItemC } from '..';
import ConfigComponent from '../config components/config.Components';
import _ from 'lodash';
import { SelectProps } from 'antd/lib/select';
import dataMapper from '../../function/dataMapper';
import { generalType } from '../../data/general';
import useGeneral from 'src/shared/hooks/useGeneral';
interface SelectComponentProps extends SelectProps<any>, BaseProps {
  api?: string;
  cName?: string;
  cValue?: string;
  apiCaller?: boolean;
  day?: boolean;
  month?: boolean;
  year?: boolean;
  dataArray?: any[];
  withOutObj?: boolean;
  generalType?: generalType;
  filterData?: any;
  getData?: Function;
  translateGeneral?: boolean;
}

const SelectComponent = (props: SelectComponentProps) => {
  const { select: selectDef } = ConfigComponent;
  const { inCol: inColDef, inForm: inFormDef } = selectDef;
  let {
    api,
    cName = 'name',
    cValue = 'id',
    placeholder,
    apiCaller = true,
    col,
    formItem,
    inForm = inFormDef,
    inCol = inColDef,
    day,
    month,
    year,
    dataArray,
    withOutObj = false,
    generalType,
    filterData,
    getData,
    translateGeneral = true,
    ...antdProps
  } = props;
  let { data, isValidating } = useSWR(
    api && api.length && apiCaller && !generalType ? api : null
  );
  const { data: generalsData } = useGeneral(generalType, translateGeneral);
  if (generalType) {
    dataArray = generalsData;
  }
  if (day) {
    dataArray = _.range(1, 32);
    withOutObj = true;
  } else if (month) {
    dataArray = [
      { id: 1, name: 'January' },
      { id: 2, name: 'Februrary' },
      { id: 3, name: 'March' },
      { id: 4, name: 'April' },
      { id: 5, name: 'May' },
      { id: 6, name: 'June' },
      { id: 7, name: 'July' },
      { id: 8, name: 'August' },
      { id: 9, name: 'September' },
      { id: 10, name: 'October' },
      { id: 11, name: 'November' },
      { id: 12, name: 'December' },
    ];
  } else if (year) {
    dataArray = _.range(1900, new Date().getFullYear()).reverse();
    withOutObj = true;
  }

  useEffect(() => {
    getData &&
      getData(
        filterData
          ? dataArrayHandle(dataArray || data).filter(filterData)
          : dataArrayHandle(dataArray || data)
      );
  }, [JSON.stringify(dataArray), JSON.stringify(data)]);
  const component = (
    <Select
      autoComplete='off'
      optionFilterProp='children'
      filterOption={(input, option: any) =>
        String(option.props.children)
          .toLowerCase()
          .indexOf(String(input).toLowerCase()) >= 0 ||
        String(option.props.value)
          .toLowerCase()
          .indexOf(String(input).toLowerCase()) >= 0
      }
      notFoundContent={
        isValidating ? (
          <div>
            <Spin size='small' />
          </div>
        ) : (
          <div style={{ textAlign: 'center' }}>
            <Empty imageStyle={{ height: '50px' }} />
          </div>
        )
      }
      {...(antdProps as any)}
      loading={isValidating}
      placeholder={placeholder || 'انتخاب کنید'}
    >
      {(filterData
        ? dataArrayHandle(dataArray || data).filter(filterData)
        : dataArrayHandle(dataArray || data)
      )?.map((item) => (
        <Select.Option
          key={withOutObj ? item : item[cValue as string]}
          value={withOutObj ? item : item[cValue as string]}
          row={item}
        >
          {withOutObj ? item : item[cName as string]}
        </Select.Option>
      ))}
    </Select>
  );

  if (inForm && !inCol) {
    return <FormItemC {...(formItem as any)}>{component}</FormItemC>;
  }

  if (inCol && !inForm) {
    return <Col {...col}>{component}</Col>;
  }
  if (inCol && inForm) {
    return (
      <Col {...col}>
        <FormItemC
          {...(formItem as any)}
          // initialValue={dataMapper(data, "id", 1, "country")}
        >
          {component}
        </FormItemC>
      </Col>
    );
  }

  return component;
};

export default SelectComponent;
